import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Http } from '@angular/http';
import "rxjs/add/operator/map";

import { ImcpaAppProvider } from '../../../providers/imcpaApp/imcpaApp';
import { MysqlService } from '../../../services/mysql.service';

// import { CowListPage } from '../cowList/cowList';
// import { CowDetailPage } from '../cowDetail/cowDetail';
import { UpdateCowPage } from '../updateCow/updateCow';
// import { CapturePhotoPage } from '../capturePhoto/capturePhoto';

// import { MedicalReportListPage } from '../medicalReportList/medicalReportList';
// import { AddMedicalReportPage } from '../addMedicalReport/addMedicalReport';

@Component({
  selector: 'page-cowDashboard',
  templateUrl: 'cowDashboard.html',
  // styleUrls: [ 'cowDashboard.scss', '../../theme/variables.scss' ]
})
export class CowDashboardPage {
  public goshala: any;
  public cow: any;
  public medicals = [];
  public myreturnvalue;

  cowDashboard: string = "profile";

  constructor(public navCtrl: NavController, public navParams: NavParams, public myApp: ImcpaAppProvider, private dbService: MysqlService) {
    this.cow = this.navParams.get("cow");
    this.goshala = this.navParams.get("goshala");
    this.getMedicalRports()
    if(this.navParams.get("cowDashboard") !== undefined){
      this.cowDashboard = this.navParams.get("cowDashboard");
    }

    // this.medicals = this.imcpaAppProvider.getMedicals();
    // console.log(this.navParams.get("cowDetails"));
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CowDetailsPage');
  }

getMedicalRports(){
    this.dbService.fetchDataV2('select * from medicalreports where goshala_id in (0,' + this.goshala.id + ') and cow_id in (0,' + this.cow.id +')')
      .map(res => res.json())
      .subscribe(res => {
          // this.loading.dismiss();
        this.medicals=res.data;
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        // this.loading.dismiss();
      });
  }

  goToUpdateCowPage() {
    this.navCtrl.push(UpdateCowPage, {
      cow: this.cow, goshala: this.goshala, type: 'update'
    });
  }

  goToCapturePhotoPage() {
    // this.navCtrl.push(CapturePhotoPage, {
    //   cow: this.cow, goshala: this.goshala
    // });
  }

  goToCowDetailPage() {
    // this.navCtrl.push(CowDetailPage, {
    //   cow: this.cow, goshala: this.goshala
    // });
  }

  goToMedicalReportListPage() {
    // this.navCtrl.push(MedicalReportListPage, {
    //   cow: this.cow, goshala: this.goshala
    // });
  }

  goToAddMedicalReportPage() {
    // this.navCtrl.push(AddMedicalReportPage, {
    //   cow: this.cow, goshala: this.goshala
    // });
  }


}



// WEBPACK FOOTER //
// ./src/pages/cows/cowDashboard/cowDashboard.ts